<app-row-header (toggleMenu)="toggleMenu()">{{ 'FOOTER.ADDITIONAL_INFORMATIONS.header' | translate }}</app-row-header>

@if (showMenuContent) {
    <ul>
        @for (item of additionalMenu; track item) {
            <li class="my-3" app-footer-menu-item [item]="item"></li>
        }
    </ul>
}
